import { j as s, I as t, d as a } from "./IconTemplate-5cea3f66.mjs";
import "react";
import "./internal.js";
const r = (c) => /* @__PURE__ */ s(t, { ...c, name: c.name || "Date", viewBox: "0 0 1024 1024", children: /* @__PURE__ */ s(
  "path",
  {
    d: "M774.92 1024H249.08C110.7 1024 0 913.3 0 774.92V304.43C0 166.05 110.7 55.35 249.08 55.35h525.84c138.38 0 249.08 110.7 249.08 249.08v470.49C1024 913.3 913.3 1024 774.92 1024M249.08 138.38c-91.33 0-166.05 74.72-166.05 166.05v470.49c0 91.33 74.72 166.05 166.05 166.05h525.84c91.33 0 166.05-74.72 166.05-166.05V304.43c0-91.33-74.72-166.05-166.05-166.05zm719.57 304.43H41.51C19.37 442.81 0 423.44 0 401.3s19.37-41.51 41.51-41.52h927.14c22.14 0 41.51 19.37 41.51 41.52s-19.37 41.51-41.51 41.51M595.03 719.57H428.97c-22.14 0-41.51-19.37-41.51-41.52s19.37-41.51 41.51-41.51h166.06c22.14 0 41.51 19.37 41.51 41.51s-19.37 41.51-41.51 41.52M332.11 193.73c-22.14 0-41.51-19.37-41.51-41.51V41.51C290.6 19.37 309.97 0 332.11 0s41.51 19.37 41.51 41.51v110.71c0 22.14-19.37 41.51-41.51 41.51m332.11 0c-22.14 0-41.51-19.37-41.52-41.51V41.51C622.7 19.37 642.07 0 664.22 0s41.51 19.37 41.51 41.51v110.71c0 22.14-19.37 41.51-41.51 41.51",
    fill: "currentColor",
    fillOpacity: "0.9"
  }
) });
r.defaultProps = a;
export {
  r as default
};
